import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { ShowHidePasswordModule } from "ngx-show-hide-password";
import { LoginComponent } from "./login/login.component";
import { NotFoundComponent } from "./not-found/not-found.component";

@NgModule({
  declarations: [LoginComponent, NotFoundComponent],
  imports: [
    CommonModule,
    FormsModule,
    ShowHidePasswordModule,
    TranslateModule
  ],
  exports: [LoginComponent]
})

export class AuthModule { }